import { ArchiveRefreshIcon } from './ArchiveRefreshIcon';

/**
 * author: Colton Wiscombe
 * id 8BFF742C-7BD5-46C0-B280-0813A2431850
 * name archive-refresh
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-refresh.svg
 * tags
 */
export const BoxRefreshIcon = ArchiveRefreshIcon;
export default BoxRefreshIcon